<article id="datacleaner-results" [ngClass]="showResultsTable ? 'reveal': ''">
    <app-loading *ngIf="isLoading"></app-loading>
    <h2 class="heading-underline">Records in your Bullhorn system that meet your criteria, grouped by years since last
        Activity, Note or since they've been added</h2>
    <table mat-table [dataSource]="searchResults?.data" class="table table-striped">
        <ng-container *ngFor="let column of columns" [matColumnDef]="column.name">
            <th mat-header-cell *matHeaderCellDef [ngClass]="column.name !== 'group' ? 'centered-cell' : ''">{{ column.label }}</th>
            <td mat-cell *matCellDef="let row" [ngClass]="column.name !== 'group' ? 'centered-cell' : ''">
                <ng-container *ngIf="column.name === 'group'; else elseBlock">
                    {{ row[column.name] }}
                </ng-container>
                <ng-template #elseBlock>
                    <button class="table-button" [disabled]="cellHasNoData(row, column)"
                            (click)="confirmCreateTearSheet(row, column)"
                            [ngClass]="cellHasNoData(row, column) ? 'table-button-disabled':''">
                        {{ row[column.name] }}
                    </button>
                </ng-template>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnTitles"></tr>
        <tr mat-row *matRowDef="let row; columns: columnTitles;"></tr>
    </table>
    <section class="footer-btns stretch-btns"> <button *ngIf="showCsvExportButton()" theme="nav" (click)="getCSV()" appRipple>Export To CSV</button> </section>
</article>
